import { render, staticRenderFns } from "./GroupInvitationNotificationModal.vue?vue&type=template&id=e6251326&"
import script from "./GroupInvitationNotificationModal.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports